import Smooch from 'gladlyinc';

import AppGateway from 'adapters/gateways/AppGateway';
import CohortGateway from 'adapters/gateways/CohortGateway';
import iOSStorageGateway from 'adapters/gateways/iOSStorageGateway';
import AndroidStorageGateway from 'adapters/gateways/AndroidStorageGateway';
import LocalStorageGateway from 'adapters/gateways/LocalStorageGateway';
import PaymentGateway from 'adapters/gateways/PaymentGateway';
import SelfServiceGateway from 'adapters/gateways/SelfServiceGateway';
import SmoochChatGateway from 'adapters/gateways/SmoochChatGateway';
import SmoochMessageGateway from 'adapters/gateways/SmoochMessageGateway';
import SmoochIntegrationDouble from '__mocks__/SmoochIntegrationDouble';
import { platforms } from 'enums/app';

export default function({ appId, provider, deviceConfig }) {
  if (provider !== 'SMOOCH' && provider !== 'INTEGRATION') {
    throw new Error(`unrecognized chat provider: ${provider}`);
  }

  const smooch = provider === 'INTEGRATION' ? new SmoochIntegrationDouble() : Smooch;
  const appGateway = new AppGateway();
  const cohortGateway = new CohortGateway();
  const selfServiceGateway = new SelfServiceGateway();
  const chatGateway = new SmoochChatGateway(smooch);
  const messageGateway = new SmoochMessageGateway(smooch);
  const paymentGateway = new PaymentGateway();
  const storageGateway = getStorageGateway(appId, deviceConfig);

  return {
    appGateway,
    chatGateway,
    cohortGateway,
    messageGateway,
    paymentGateway,
    selfServiceGateway,
    storageGateway,
  };
}

function getStorageGateway(appId, deviceConfig) {
  const { platform } = deviceConfig;
  if (platform === platforms.IOS) {
    return new iOSStorageGateway(deviceConfig.storedState);
  } else if (platform === platforms.ANDROID) {
    return new AndroidStorageGateway(deviceConfig.storedState);
  }
  return new LocalStorageGateway(appId);
}
